import React, { Component } from 'react';
import { Alert, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import './Login.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { login } from '../../store/loginActions';
import { Link } from 'react-router-dom';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: ''
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    this.props.login(this.state.email, this.state.password);
    return false;
  }

  render() {
    return (
      <div className="login-container">
        {this.props.error && <Alert color="danger">{this.props.error}</Alert>}
        <Form className={'login-form'} onSubmit={e => this.onSubmit(e)}>
          <h2 className="mb-4">Store Builder Login</h2>
          <FormGroup>
            <Label for="email">Email address</Label>
            <Input
              type="email"
              id="email"
              placeholder="you@email.com"
              onChange={e => this.setState({ email: e.target.value })}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">Password</Label>

            <Input
              type="password"
              id="password"
              onChange={e => this.setState({ password: e.target.value })}
              required
            />
            <div className="mt-2">
              <Link to="/forgot-password" title="I forgot my password">
                Forgot your password?
              </Link>
            </div>
          </FormGroup>

          <Button color="primary" className="btn-block">
            Log in
          </Button>
        </Form>
      </div>
    );
  }
}

export { Login };

const mapStateToProps = ({ login }) => {
  return {
    error: login.error
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      login
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js